import datapoints from '../datapoints';
import { action } from 'satcheljs';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
/**
 * Load search message suggestion
 * @param suggestion the message suggestion
 */
var loadMessageSuggestion = action('loadMessageSuggestion', function (suggestion) {
    return {
        suggestion: suggestion,
        datapointConfig: {
            name: datapoints.LoadMessageSuggestionDatapoint.datapoint.name,
            customData: {
                isOpenedInTab: is3SFeatureEnabled('sea-emailSuggestionsInTab'),
            },
        },
    };
});
export default loadMessageSuggestion;
//# sourceMappingURL=loadMessageSuggestion.js.map